import { VwgAction, VwgActions } from '../vwgActions';
import { AntragsummerGenerated } from '../action-types/antragsummerGenerated';
import { IAppState } from '../appState';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: VwgAction<AntragsummerGenerated>,
  state: IAppState,
): string {
  if (action.type === VwgActions.ANTRAGSNUMMER_GENERATED && action.payload.angebotsId === state.angebotsId) {
    return action.payload.antragsnummer;
  }
  return sectionState;
};
